<template>
    <Head title="Login" />

    <div class="flex min-h-[88px] bg-[#1d3557]">
        <div class="w-full max-w-[1440px] h-full m-auto px-[20px]">
            <Link
                class="text-[#fff] text-[32px]"
                :href="`/`"
            >
                Materialbeställning
            </Link>
        </div>
    </div>

    <div class="flex items-start min-h-[calc(100vh-558px)] justify-center bg-[#f4f7fa] p-6">
        <div class="w-full max-w-md">
            <form class="mt-8 overflow-hidden" @submit.prevent="login">
                <div class="px-10 py-12">
                    <h1 class="text-center text-3xl font-bold text-[#9199a5]">{{ __('Logga in') }}</h1>

                    <div class="mx-auto mt-6 w-24 border-b-2" />

                    <TextInput
                        v-model="form.email"
                        :error="form.errors.email"
                        class="mt-10"
                        :label="__('Email')" type="email"
                        autofocus
                        autocapitalize="off"
                    />

                    <TextInput
                        v-model="form.password"
                        :error="form.errors.password"
                        class="mt-6"
                        :label="__('Password')"
                        type="password"
                    />

                    <label class="mt-6 flex select-none items-center" for="remember">
                        <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
                        <span class="text-sm">{{ __('Remember Me') }}</span>
                    </label>
                </div>

                <div class="flex items-center justify-center border-t border-gray-100 px-10 py-4">
                    <LoadingButton
                        :loading="form.processing"
                        class="bg-[#82bf56] hover:bg-blue-700 text-white font-bold py-4 px-8 rounded"
                        type="submit"
                    >
                        {{ __('Login') }}
                    </LoadingButton>
                </div>
            </form>
        </div>
    </div>

    <div class="flex min-h-[470px] bg-[#1d3557]">
        <div class="w-full max-w-[1440px] h-full m-auto px-[20px]">
            <div class="flex justify-start items-center text-[#fff] text-[13px]">
                <img src="/img/pfzier-logo-white.svg" class="max-w-[130px]" alt="Pfizer AB">
                <span class="text-[#fff] font-bold ml-[15px]">Pfizer AB</span>, org.nr 556059-6255
            </div>

            <p class="text-[#fff] text-[13px] leading-[18px]">
                <br>
                <br>
                Vetenskapsvägen 10,<br>
                191 90 Sollentuna<br>
                tel: 08-550 52 000<br>
                Fax: 08-550 52 010
                <br>
                <br>
                Denna webbsite är avsedd för personer bosatta i Sverige.<br>
                Pfizer innehar upphovsrätten till denna site och reserverar sig alla rättigheter därtill.
            </p>
        </div>
    </div>
</template>

<script>
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Logo           from '@/Shared/Logo'
    import TextInput      from '@/Shared/TextInput'
    import LoadingButton  from '@/Shared/LoadingButton'

    export default {
        components: {
            Head,
            Link,
            LoadingButton,
            Logo,
            TextInput,
        },
        data() {
            return {
                form: this.$inertia.form({
                    email: 'test@example.com',
                    password: 'secret',
                    remember: false,
                })
            }
        },
        methods: {
            login() {
                this.form.post('/login')
            }
        }
    }
</script>
